import { ShapeVariant } from '@elearning-platform/ui';

import { AddonConfig } from '../../../interfaces';

export const addons: AddonConfig[] = [
  {
    key: 'withAccommodation',
    shape: ShapeVariant.Bed,
    label: 'competence.app.eventFormDrawer.bookAccommodation',
  },
  {
    key: 'withParking',
    shape: ShapeVariant.Parking,
    label: 'competence.app.eventFormDrawer.bookParking',
  },
  {
    key: 'withDinner',
    shape: ShapeVariant.Pizza,
    label: 'competence.app.eventFormDrawer.bookSupper',
  },
  {
    key: 'withVege',
    shape: ShapeVariant.Plant,
    label: 'competence.app.eventFormDrawer.vegeMeal',
  },
];
